import Component from '../core/Component'
import Scroll from '../services/Scroll'
import { queries } from '../core/config'
import enquire from 'enquire.js'
import zip from 'lodash/zip'
import { queryAll } from '../utils/dom'

const defaults = {
    media: null,
    query: '',
    groupBy: null
}

export default class Equalize extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            items: [],
            groups: []
        }

        if (this.options.media) {
            this.options.query = queries[this.options.media] || this.options.media
        }

        this.enquireHandler = {
            match: this.attach,
            unmatch: this.detach
        }

        this.isActive = false
    }

    prepare() {
        if (this.options.query) {
            enquire.register(this.options.query, this.enquireHandler)
        } else {
            this.attach()
        }
    }

    destroy() {
        if (this.options.query) {
            enquire.unregister(this.options.query, this.enquireHandler)
        } else {
            this.detach()
        }
    }

    attach = () => {
        Scroll.on('resize', this.handleResize)
        this.resize()
    }

    detach = () => {
        Scroll.on('resize', this.handleResize)
        this.ref.items.forEach(element => element.removeAttribute('style'))
    }

    handleResize = event => {
        this.resize()
    }

    resize() {
        if (this.options.groupBy && this.ref.groups.length) {
            const groups = zip(...this.ref.groups.map(element => queryAll(this.options.groupBy, element)))
            groups.flat().forEach(element => element.removeAttribute('style'))
            groups.forEach(items => {
                const height = Math.max(...items.map(item => item.scrollHeight))
                items.forEach(item => item.style.height = `${height}px`)
            })
        } else {
            this.ref.items.forEach(item => item.removeAttribute('style'))
            const height = Math.max(...this.ref.items.map(item => item.scrollHeight))
            this.ref.items.forEach(item => item.style.height = `${height}px`)
        }
    }
}
